module.exports = __webpack_public_path__ + "img/beltegoed.7064a45.svg";